

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { msalConfig } from './authConfig'
import reportWebVitals from './reportWebVitals'

// Initialize MSAL instance with the provided configuration
const msalInstance = new PublicClientApplication(msalConfig)

// Get the root container and ensure it's non-null
const container = document.getElementById('root')
if (!container) throw new Error('Root container not found')

// Create root and render the App with MSAL context
const root = createRoot(container)

// Wrap App with MsalProvider to provide MSAL context to the app
root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
)

// Report web vitals (optional)
reportWebVitals()